import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//
import Spinner from './components/Spinner';
import ability from './configs/acl/ability';
import './index.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import { AbilityContext } from './utility/context/Can';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AbilityContext.Provider value={ability}>
        <LazyApp />
        <ToastContainer newestOnTop limit={4} />
      </AbilityContext.Provider>
    </Suspense>
  </Provider>
);

reportWebVitals();
